var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHbar = function SvgHbar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3817 40.1098H35.826V32.5501H20.1737V40.1098H16.6177V15.5959H20.1737V22.9738H35.826V15.5959H39.382L39.3817 40.1098ZM20.3417 29.7218H35.9937V25.8159H20.3417V29.7218Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.4167C12.8582 55.4167 0.583333 43.1418 0.583333 28H-0.583333C-0.583333 43.7861 12.2139 56.5833 28 56.5833V55.4167ZM55.4167 28C55.4167 43.1418 43.1418 55.4167 28 55.4167V56.5833C43.7861 56.5833 56.5833 43.7861 56.5833 28H55.4167ZM28 0.583333C43.1418 0.583333 55.4167 12.8582 55.4167 28H56.5833C56.5833 12.2139 43.7861 -0.583333 28 -0.583333V0.583333ZM28 -0.583333C12.2139 -0.583333 -0.583333 12.2139 -0.583333 28H0.583333C0.583333 12.8582 12.8582 0.583333 28 0.583333V-0.583333Z",
    fill: "white",
    fillOpacity: 0.1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHbar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "HBAR.1a1a3a92925c9595d6559b3afb5429db.svg";